/**
 * Watch for quantity changes
 */
import handler from './handler';

const quantityChange = function () {
	document.querySelector( 'body' )?.addEventListener( 'change', handler );
};

export default quantityChange;
